import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const formatDateTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

export const getTaskStatusColor = (status) => {
  const colors = {
    'new': 'bg-blue-100 text-blue-700 border-blue-200',
    'in_progress': 'bg-purple-100 text-purple-700 border-purple-200',
    'review': 'bg-amber-100 text-amber-700 border-amber-200',
    'revision': 'bg-orange-100 text-orange-700 border-orange-200',
    'completed': 'bg-green-100 text-green-700 border-green-200',
    'cancelled': 'bg-red-100 text-red-700 border-red-200',
  };
  return colors[status] || 'bg-charcoal-100 text-charcoal-700 border-charcoal-200';
};

export const getStatusColor = (status) => {
  const colors = {
    'Draft': 'bg-charcoal-100 text-charcoal-700 border-charcoal-200',
    'Submitted': 'bg-pink-100 text-pink-700 border-pink-200',
    'Under Review': 'bg-blue-100 text-blue-700 border-blue-200',
    'Shortlisted': 'bg-purple-100 text-purple-700 border-purple-200',
    'Interview Scheduled': 'bg-purple-100 text-purple-700 border-purple-200',
    'Interview Completed': 'bg-indigo-100 text-indigo-700 border-indigo-200',
    'Offer Extended': 'bg-green-100 text-green-700 border-green-200',
    'Hired': 'bg-green-100 text-green-800 border-green-200',
    'Accepted': 'bg-green-100 text-green-800 border-green-200',
    'Onboarding In Progress': 'bg-blue-100 text-blue-700 border-blue-200',
    'Onboarding Complete': 'bg-green-100 text-green-800 border-green-200',
    'Rejected': 'bg-red-100 text-red-700 border-red-200',
  };
  return colors[status] || 'bg-charcoal-100 text-charcoal-700 border-charcoal-200';
};